import { useQuery } from '@tanstack/react-query';
import { client, OverallStatusFilter } from '../../api';
import { RxFilterValues } from '../../types';

export const useHasAwaitingOffice = (search: string, filterValues: RxFilterValues) => {
  const { prescriber, office, drug, drug_category, status, startDate, endDate } = filterValues;

  return useQuery({
    queryKey: ['has-awaiting-office', search, prescriber, office, drug, drug_category, status, startDate, endDate],
    queryFn: () =>
      client
        .get('/rxs/awaiting-office-count', {
          params: {
            search,
            prescriber_npi: prescriber,
            office_name: office,
            drug_name: drug,
            drug_category,
            status,
            overall_status: OverallStatusFilter.InProgress,
            created_at_start: startDate || undefined,
            created_at_end: endDate || undefined,
          },
        })
        .then((res) => res.data.count > 0),
  });
};
